import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { environment } from './environments/environment';

// Suppress console output in production builds
if (environment && typeof window !== 'undefined') {
	window.console.log = function () {};
	window.console.warn = function () {};
	window.console.error = function () {};
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
